import {useReducer} from "react";
import {userRoleActions, userRoleInitialState, userRoleReducer} from "../provider/~reducer";
import {deleteData, postData, putData, sendRequestAuth} from "../../../api/api";
import config from "../../../config";
import toast from "../../../Component/Toast";
import {useLocation, useNavigate} from "react-router-dom";
const useUserRole = () => {
  const [state, dispatch] = useReducer(userRoleReducer, userRoleInitialState)
  const navigate = useNavigate()
  const location = useLocation()

  const nameRole = state.formCreateRole.name.value
  const noteRole = state.formCreateRole.note.value
  const errorName = state.validate.name

  const handleUserRole = async () => {

    const idRole = location.pathname.split('/')[3]
    // CREATE USER ROLE
    if(location.pathname.split('/')[2] === 'create' && !!!idRole) {
      const response = await Promise.all([
        sendRequestAuth('get', `${config.API}/permission-module`),
      ])
      if(response[0]?.data?.success) {
        let listRole = response[0]?.data?.data?.data
        const result = transformData(listRole)

        dispatch({ type: userRoleActions.LIST_PERMISSION, payload: result })
        dispatch({ type: userRoleActions.LIST_FEATURES, payload: result[0]?.features })
        dispatch({ type: userRoleActions.LIST_FEATURE_ACTIONS, payload: [result[0]?.features[0]] })
        dispatch({ type: userRoleActions.SET_ACTIVE_SIDE_BAR, payload: result[0].module_id })
      }
    }
    // UPDATE USER ROLE
    else {
      const response = await Promise.all([
        sendRequestAuth('get', `${config.API}/user/groups/${idRole}`),
      ])
      if(response[0]?.data?.success) {
        let listRole = response[0]?.data?.data
        transformDataEdit(listRole)
      }
    }
  }

  const transformDataEdit = listRole => {
    console.log(listRole)
    let checkAll = true
    const roles = listRole?.module?.map(item => {
      item.module_id = item.id
      item.features = listRole?.permission_details?.filter(it => it.permission_module.id === item.id)
      item.features.map(it => {
        it.feature_actions = JSON.parse(it.permission_feature.feature_actions)
        it.actions = JSON.parse(it.actions_permission)
        it.feature_actions.map(ac => {
          ac.active = +it.actions[ac.code] === 1
          if(!ac.active) checkAll = false
          return ac
        })
        it.feature_name = it.permission_feature.feature_name
        return it
      })
      return item
    })

    if(checkAll) dispatch({ type: userRoleActions.SET_ACTIVE_CHECK_ALL_PER, payload: true })
    dispatch({ type: userRoleActions.UPDATE_FORM_CREATE_NAME, payload: { value: listRole?.group_name }})
    dispatch({ type: userRoleActions.UPDATE_FORM_CREATE_NOTE, payload: { value: listRole?.group_comment }})
    dispatch({ type: userRoleActions.LIST_PERMISSION, payload: roles })
    dispatch({ type: userRoleActions.LIST_FEATURES, payload: roles[0]?.features })
    dispatch({ type: userRoleActions.LIST_FEATURE_ACTIONS, payload: [roles[0]?.features[0]] })
    dispatch({ type: userRoleActions.SET_ACTIVE_SIDE_BAR, payload: roles[0].module_id })
    return roles
  }

  const transformData = listRole => {
    return listRole.map(item => {
      item.module_id = item.id
      item.features = item.permission_features
      item.features.map(it => {
        it.feature_actions = JSON.parse(it.feature_actions)
        return it
      })
      return item
    })
  }

  const handleUserRoleList = async () => {
    const response = await Promise.all([
      sendRequestAuth('get', `${config.API}/user/groups`),
    ])
    if(response[0]?.data?.success) {
      const userRole = response[0]?.data
      dispatch({ type: userRoleActions.USER_ROLE_LIST, payload: userRole?.data })
    }
  }

  const handleClickItemAction = (feat, ac) => {
    dispatch({ type: userRoleActions.CHANGE_FORM_CREATE, payload: true})
    if(!state.activeCheckAllPer) {
      const listFeatures = state.listFeatures.map(item => {
        if(ac.code === 'view' && ac.active && item.feature_code === feat.feature_code) {
          item.feature_actions.map(it => {
            it.active = false
          })
        } else if(ac.code !== 'view' && !!!ac.active && item.feature_code === feat.feature_code) {
          item.feature_actions.map(it => {
            if((it.code === 'view' || it.code === 'detail')) {
              it.active = true
            } else if(ac.code === it.code && !it.active) {
              it.active = true
            } else if(ac.code === it.code && it.active) {
              it.active = false
            }
          })
        } else if(item.feature_code === feat.feature_code) {
          item.feature_actions.map(it => {
            if(ac.code === it.code && !it.active) {
              it.active = true
            } else if(ac.code === it.code && it.active) {
              it.active = false
            }
          })
        }
        return item
      })
      dispatch({type: userRoleActions.LIST_FEATURES, payload: listFeatures})
    }
  }

  const checkboxItemGroup = feat => {
    const checked = feat.feature_actions.filter(item => item.active)
    return checked.length > 0
  }

  const checkboxItemGroupAll = feat => {
    const checkAll = feat.feature_actions.find(item => !item.active)
    return !!!checkAll
  }

  const checkboxItemAction = (act, ac) => {
    const checked = act.feature_actions.find(item => item.code === ac.code)
    return checked.active
  }

  const handleClickCheckAllItem = feat => {
    const checkAll =  feat.feature_actions.filter(item => item.active)
    const listFeatures = state.listFeatures.map(item => {
      if(item.feature_code === feat.feature_code) {
        item.feature_actions.map(it => {
          it.active = checkAll.length === 0
        })
      }
      return item
    })
    dispatch({type: userRoleActions.LIST_FEATURES, payload: listFeatures})
    dispatch({ type: userRoleActions.CHANGE_FORM_CREATE, payload: true})
  }

  const handleShowDetailRow = feat => {
    // if(!state.activeCheckAllPer) {
      let listActions
      if(!!!state.featureActions.find(it => it.feature_code === feat.feature_code)) {
        listActions = [...state.featureActions, feat]
      } else {
        listActions = state.featureActions.filter(item => item.feature_code !== feat.feature_code)
      }
      dispatch({ type: userRoleActions.LIST_FEATURE_ACTIONS, payload: listActions })
    // }
  }

  const handleClickSidebarRole = item => {
    dispatch({ type: userRoleActions.SET_ACTIVE_SIDE_BAR, payload: item.module_id })
    dispatch({ type: userRoleActions.LIST_FEATURES, payload: item.features })
    dispatch({ type: userRoleActions.LIST_FEATURE_ACTIONS, payload: item.features })
  }

  const listSubHeader = feat => {
    return feat.feature_actions.filter(item =>  item.active)
  }

  const showTick = item => {
    let checkTick = false
    item.features.map(feat => {
      if(feat.feature_actions.find(it => it.active)) checkTick = true
    })
    return checkTick
  }

  const handleClickAllPermission = () => {
    dispatch({ type: userRoleActions.CHANGE_FORM_CREATE, payload: true})
    if(state.activeCheckAllPer) {
      const list = state.listPermission.map(item => {
        item.features.map(feat => {
          feat.feature_actions.map(act => {
            act.active = false
          })
        })
        return item
      })
      dispatch({ type: userRoleActions.SET_ACTIVE_CHECK_ALL_PER, payload: false })
      dispatch({ type: userRoleActions.LIST_PERMISSION, payload: list })
    } else {
      const list = state.listPermission.map(item => {
        item.features.map(feat => {
          feat.feature_actions.map(act => {
            act.active = true
          })
        })
        return item
      })
      dispatch({ type: userRoleActions.SET_ACTIVE_CHECK_ALL_PER, payload: true })
      dispatch({ type: userRoleActions.LIST_PERMISSION, payload: list })
    }
  }

  const handleChangeName = name => {
    dispatch({ type: userRoleActions.UPDATE_FORM_CREATE_NAME, payload: { value: name }})
    dispatch({ type: userRoleActions.CHANGE_FORM_CREATE, payload: true})

    if(!!name) {
      dispatch({ type: userRoleActions.VALIDATE_FORM_CREATE_NAME, payload: { status: false, message: '' }})
    }
  }

  const handleChangeNote = note => {
    dispatch({ type: userRoleActions.UPDATE_FORM_CREATE_NOTE, payload: { value: note }})
    dispatch({ type: userRoleActions.CHANGE_FORM_CREATE, payload: true})
  }

  const handleSubmitUserRole = () => {
    if(!!!nameRole) {
      dispatch({ type: userRoleActions.VALIDATE_FORM_CREATE_NAME, payload: { status: true, message: 'Tên vai trò không được để trống!' }})
      return
    }

    let result = []
    state.listPermission.map(item => {
      item.features.map(feat => {
        let obj = {}
        feat.feature_actions.map(act => {
          obj[act.code] = act.active ? '1' : '0'
        })
        result[result.length] =  {
          "module_code": item.module_code,
          "feature_code": feat.feature_code,
          "feature_actions": obj
        }
      })
      return result
    })


    const idRole = location.pathname.split('/')[3]
    const dataPost = {
      "group_name": nameRole,
      "group_comment": noteRole,
      "permission": result
    }
    // CREATE USER ROLE
    if(location.pathname.split('/')[2] === 'create' && !!!idRole) {
      const url = `${config.API}/user/groups`
      postData(url, dataPost)
        .then(res => {
          if (res?.data && res?.data?.success) {
            toast.success(res?.data?.message)
            navigate('/user/groups')
          } else {
            toast.error('Thêm mới vai trò thất bại!')
          }
        })
    }
    // UPDATE USER ROLE
    else {
      const url = `${config.API}/user/groups/${idRole}`
      const response = putData(url, dataPost)
      response.then(res => {
        if(res?.success) {
          toast.success('Cập nhật vai trò thành công')
          navigate('/user/groups')
        } else {
          toast.error('Cập nhật vai trò thất bại')
        }
      })

    }

  }

  const handleBlurName = () => {
    if(!!!nameRole) {
      dispatch({ type: userRoleActions.VALIDATE_FORM_CREATE_NAME, payload: { status: true, message: 'Tên vai trò không được để trống!' }})
    } else {
      dispatch({ type: userRoleActions.VALIDATE_FORM_CREATE_NAME, payload: { status: false, message: '' }})
    }
  }

  const backToList = () => {
    if(!state.changeFormCreate) {
      navigate('/user/groups')
    } else {
      dispatch({ type: userRoleActions.OPEN_MODAL_CONFIRM, payload: true})
    }
  }

  const closeModalRoleConfirm = () => dispatch({ type: userRoleActions.OPEN_MODAL_CONFIRM, payload: false})

  const acceptanceModalRoleConfirm = () => {
    dispatch({ type: userRoleActions.OPEN_MODAL_CONFIRM, payload: false})
    navigate('/user/groups')
  }

  const closeModalRoleConfirmDelete = () => dispatch({ type: userRoleActions.OPEN_MODAL_CONFIRM_DELETE, payload: false})

  const acceptanceModalRoleConfirmDelete = async () => {
    dispatch({ type: userRoleActions.OPEN_MODAL_CONFIRM_DELETE, payload: false})
    const data = state.userRoleBeforeDelete
    const url = `${config.API}/admin/group/delete/${data.id}`
    toast.warning('Tính năng đang phát triển')
    const response = await sendRequestAuth('DELETE', url)
    if(response?.data?.success) {
      toast.success(response?.data?.errors?.message)
      // LOAD PAGE
      const fetch = async () => {
        const response = await Promise.all([
          sendRequestAuth('get', `${config.API}/user/groups`),
        ])
        if(response[0]?.data?.success) {
          dispatch({ type: userRoleActions.USER_ROLE_LIST, payload: response[0]?.data.data })
          dispatch({type: userRoleActions.SET_PAGINATION, payload: {
              active: state.paginate.active,
              amount: state.paginate.amount,
              total: Math.ceil(response[0]?.data?.data.length / state.paginate.amount),
              totalItems: response[0]?.data?.data.length,
            }})
        }
      }
      fetch()
    } else {console.log('ERROR')}
  }

  const handlePaginationAmountChange = async amount => {
    dispatch({type: userRoleActions.SET_LOADING, payload: true })
    const response = await Promise.all([
      sendRequestAuth('get', `${config.API}/user/groups?per_page=${amount}&start=0`),
    ])

    if (response[0]?.data?.success) {
      const userRole = response[0]?.data
      dispatch({type: userRoleActions.SET_LOADING, payload: false })
      dispatch({type: userRoleActions.USER_ROLE_LIST, payload: userRole?.data?.data})
      dispatch({type: userRoleActions.SET_PAGINATION, payload: {
          active: 0,
          amount: amount,
          total: Math.ceil(userRole?.data?.total / amount),
          totalItems: userRole?.data?.total,
        }})
    }
  }

  const handlePaginationPageChange = async page => {
    dispatch({type: userRoleActions.SET_LOADING, payload: true })
    const amount = state?.paginate?.amount || 20
    const response = await Promise.all([
      sendRequestAuth('get', `${config.API}/user/groups?per_page=${amount}&start=${page*amount}`),
    ])
    if (response[0]?.data?.success) {
      const userRole = response[0]?.data
      dispatch({type: userRoleActions.SET_LOADING, payload: false })
      dispatch({type: userRoleActions.USER_ROLE_LIST, payload: userRole?.data?.data})
      dispatch({type: userRoleActions.SET_PAGINATION, payload: {
          active: page,
          amount: amount,
          total: Math.ceil(userRole?.data?.total / amount),
          totalItems: userRole?.data?.total,
        }
      })
    }
  }

  return {
    provider: {state, dispatch},
    fetch: {
      userRole: handleUserRole,
      userRoleList: handleUserRoleList,
    },
    functions: {
      handleClickItemAction,
      handleClickCheckAllItem,
      handleShowDetailRow,
      handleClickSidebarRole,
      handleClickAllPermission,
      handleChangeName,
      handleChangeNote,
      handleSubmitUserRole,
      backToList,
      closeModalRoleConfirm,
      acceptanceModalRoleConfirm,
      closeModalRoleConfirmDelete,
      acceptanceModalRoleConfirmDelete,
    },
    value: {
      checkboxItemGroupAll,
      checkboxItemGroup,
      checkboxItemAction,
      listSubHeader,
      showTick,
      nameRole,
      noteRole,
    },
    validate: {
      handleBlurName,
      errorName
    },
    handlePaginationAmountChange,
    handlePaginationPageChange
  }
}

export default useUserRole;